// extracted by mini-css-extract-plugin
export default {"main":"Footer_main__6S4ub","main__title":"Footer_main__title__EK0m4","main__social":"Footer_main__social__jWFzT","main__subtitle":"Footer_main__subtitle__WevLi"};